import { useCallback, useEffect, useRef, useState } from 'react';

type AnimatedCloseOptions = {
  durationMs?: number;
};

export function useAnimatedClose(onClose: undefined | (() => void), options: AnimatedCloseOptions = {}) {
  const durationMs = options.durationMs ?? 180;
  const [isClosing, setIsClosing] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const close = useCallback(() => {
    if (!onClose) return;

    setIsClosing(true);
    timeoutRef.current = window.setTimeout(() => {
      onClose();
    }, durationMs);
  }, [durationMs, onClose]);

  return { close, isClosing };
}
